import axios from "axios";
import api from "../utils/axiosInterceptor";
const API_URL = process.env.REACT_APP_API_URL;

export const PendingUpdateSignupService = async (data) => {
	try {
		const config = {
			headers: {
				"Content-Type": data instanceof FormData ? "multipart/form-data" : "application/json",
			},
		};
		const response = await axios.post(`${API_URL}/api/pending/user/update/signup`, data, config);
		return response.data;
	} catch (error) {
		console.error("Register error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};

export const PendingBusinessVerificationPromptService = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/pending/user/business/verification/check`, data);
		return response.data;
	} catch (error) {
		console.error("Verify email change Code error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};

export const PendingSendEmailChangeOtpService = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/pending/user/email/send-otp`, data);
		return response.data;
	} catch (error) {
		console.error("Verify email change Code error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};

export const PendingVerifyEmailChangeOtpService = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/pending/user/email/verify-otp`, data);
		return response.data;
	} catch (error) {
		console.error("Verify email change Code error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};

export const PendingSendPhoneChangeOtpService = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/pending/user/phone/send-otp`, data);
		return response.data;
	} catch (error) {
		console.error("Verify email change Code error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};

export const PendingVerifyPhoneChangeOtpService = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/pending/user/phone/verify-otp`, data);
		return response.data;
	} catch (error) {
		console.error("Verify email change Code error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};

export const PendingGetBusinessVerifiedService = async () => {
	try {
		const response = await api.get(`${API_URL}/api/pending/user/get/business-verified`);
		return response.data;
	} catch (error) {
		console.error("Verify email change Code error:", error);
		return error.response?.data || {status: false, message: error.message};
	}
};
